var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"CheckBox",class:{checked: _vm.isChecked(), disabled: _vm.isDisabled},on:{"click":_vm.toggle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }